<template>
  <div class="WriteBlog">
    <div class="editor">
      <div class="title">
        <select name="original" class="original" v-model="isOriginal">
          <option value="原创">原创</option>
          <option value="转载">转载</option>
        </select>
        <input type="text" placeholder="我的新博客..." v-model="articleTitle" />
      </div>
      <mavon-editor
        class="mavonEditor"
        @save="save"
        :toolbars="toolbars"
        :subfield="subfield"
        :toolbarsFlag="toolbarsFlag"
        :ishljs="ishljs"
        :codeStyle="codeStyle"
        v-model="articleValue"
        :placeholder="placeholder"
        @change="change"
        @imgAdd="imgAdd"
        @imgDel="imgDel"
        ref="mavon"
      ></mavon-editor>
      <div class="button recordInfo">
        <span style="margin-right: 10px">{{
          saveRecord ? "最后一次暂存时间：" + lastTime : "未暂存"
        }}</span
        ><button @click="clearLocal()" v-show="saveRecord">清除暂存</button>
      </div>
    </div>
    <div class="column">
      <div class="title">
        <span class="chinese">分类</span>
        <span class="english">GATEGORIES:</span>
      </div>
      <ul>
        <li
          :class="{ active: chooseColumn === key }"
          v-for="(value, key) in col"
          :key="key"
          @click="chooseCol(key, value)"
        >
          {{ key }}
        </li>
      </ul>
      <div v-show="addColumnShow" class="addColumn">
        <input
          type="text"
          placeholder="添加分类..."
          ref="addColumn"
          v-model="addColumnInfo"
          @keypress.enter="addColumnSure"
        />
        <button @click="addColumnSure">确定</button>
      </div>
      <button class="more" @click="addColumn">添加更多</button>
    </div>
    <div class="tags">
      <div class="title">
        <span class="chinese">标签</span>
        <span class="english">TAGS:</span>
      </div>
      <ul class="addTagsInfo">
        <li v-for="(item, index) in tags" :key="index">
          <span class="info"
            >{{ item }}
            <i @click="deleteTag" :index="index">×</i>
          </span>
          <span class="bugle"></span>
        </li>
      </ul>
      <div class="input">
        <input
          type="text"
          placeholder="请输入标签，最多三个，Enter提交"
          v-model="enterTagsInfo"
          @keypress.enter="addTagsSure"
        />
      </div>
    </div>
    <div class="button">
      <button class="active" @click="addArticle(true)" v-if="this.allowPush">
        发布
      </button>
      <button @click="addArticle(false)">保存草稿</button>
    </div>
    <v-Alert
      v-show="alertShow"
      :info="alertInfo"
      @confirm="confirm"
      @cancel="cancel"
    ></v-Alert>
    <div class="loading" v-if="loadingShow">
      <div class="icon iconfont icon-loading"></div>
    </div>
  </div>
</template>

<script>
import {
  pushArticle,
  pushDraft,
  currentUser,
  queryOneArticle,
  queryOneDraft,
  deatroyDraft,
  deatroyArticle,
  getTotalCategories
} from "@/bmob";
import Alert from "@/components/common/alert/alert";
export default {
  data() {
    return {
      userId: "",
      articleTitle: "",
      isOriginal: "原创",
      articleValue: "",
      articleHtml: "",
      col: {},
      chooseColumn: "",
      addColumnShow: false,
      addColumnInfo: "",
      tags: [],
      articlePushId: "",
      draftPushId: "",
      enterTagsInfo: "",
      placeholder: "请使用Markdown语法编辑...",
      saveRecord: "", //暂存记录
      lastTime: "", //最后一次暂存时间
      alertShow: false,
      alertInfo: "",
      subfield: true,
      allowPush: true, //是否允许发布
      toolbarsFlag: true, //工具栏显示
      codeStyle: "vs2015", //代码样式
      ishljs: true, //代码高亮
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true // 预览
      },
      imgListObj: {}, //markDown上的图片路径
      bmobFileList: [], //已上传bomob的文件路径列表
      loadingShow: false
    };
  },
  components: {
    "v-Alert": Alert
  },
  watch: {
    $route(to, from) {
      //判断是否从文章中来
      if (from.path.indexOf("/article") > -1) {
        //初始化
        this.initUserInfo();
      }
    },
    articleTitle() {
      //文章标题改变时自动暂存
      this.autoSave();
    },
    articleValue() {
      //文章内容改变时自动暂存
      this.autoSave();
    },
    chooseColumn() {
      //选择分类改变时自动暂存
      this.autoSave();
    },
    tags() {
      //选择标签改变时自动暂存
      this.autoSave();
    }
  },
  created() {
    this.initUserInfo();
    if (this.browserRedirect()) {
      // this.toolbars = {}
      // 移动端,markDown功能
      this.toolbarsFlag = true;
      this.subfield = false;
      this.toolbars = {
        link: true, // 链接
        imagelink: true, // 图片链接
        code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        help: true, // 帮助
        /* 1.3.5 */
        undo: true, // 上一步
        redo: true, // 下一步
        trash: true, // 清空
        save: true, // 保存（触发events中的save事件）
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true // 右对齐
      };
    }
  },
  methods: {
    initPage() {
      let articleId = this.$route.params.id;
      let type = this.$route.params.type;
      if (type === "draft") {
        // 从草稿箱来
        this.getDraftInfo(articleId);
        this.getCategories();
      } else if (type === "blog") {
        // 从发布后的文章来
        this.getArticleInfo(articleId);
        this.getCategories();
      } else {
        // 直接访问编写博客功能
        //获取暂存到本地的文章
        var articleInfo = JSON.parse(
          window.localStorage.getItem("articleInfo")
        );
        this.saveRecord = articleInfo;
        //如果有暂存文章，显示暂存的文章
        if (articleInfo) {
          this.articleTitle = articleInfo.title; //获取文章标题
          this.articleValue = articleInfo.content; //获取文章内容
          //获取文章的所有分类信息
          let colAry = articleInfo.col;
          colAry.forEach((item, index) => {
            this.col[item] = index;
          });
          //获取选择的分类
          this.chooseColumn = articleInfo.chooseColumn; //分类名
          this.tags = articleInfo.tags; //获取文章标签
          //获取文章id(用来判断是新发布还是更新旧文章)
          this.articlePushId = articleInfo.articlePushId;
        } else {
          //如果没有暂存文章
          //只需要提取所有文章的分类标签
          this.getCategories();
        }
      }
    },
    getUserId() {
      return (
        window.localStorage.getItem("userId") ||
        this.$route.query.userId ||
        undefined
      );
    },
    // 获取分类
    getCategories() {
      this.loadingShow = true;
      const userId = this.getUserId();
      getTotalCategories({ userId })
        .then(result => {
          this.loadingShow = false;
          let colObj = {};
          result.forEach(item => {
            // 遍历获取标签名为key数量为value
            colObj[item.col] = item._count;
          });
          this.col = colObj;
        })
        .catch(err => {
          this.loadingShow = false;
          console.log(err);
        });
    },
    getDraftInfo(draftId) {
      this.loadingShow = true;
      queryOneDraft(draftId)
        .then(res => {
          this.loadingShow = false;
          if (Object.keys(this.col).indexOf(res.col) > -1) {
            // 文章列表中是否有这个值
            this.chooseColumn = res.col;
          } else {
            this.col[res.col] = null;
            this.chooseColumn = res.col;
          }
          this.draftPushId = res.ID;
          this.articleTitle = res.mainTitle;
          this.articleValue = res.content;
          this.getBmobFileList(res.content);
          this.tags = res.tags;
          this.isOriginal = res.original;
        })
        .catch(err => {
          this.loadingShow = false;
          this.$emit("showMessage", err);
        });
    },
    getArticleInfo(articleId) {
      this.loadingShow = true;
      queryOneArticle(articleId)
        .then(res => {
          this.loadingShow = false;
          this.articlePushId = res.ID;
          this.articleTitle = res.mainTitle;
          this.articleValue = res.content;
          this.getBmobFileList(res.content);
          this.chooseColumn = res.col;
          this.tags = res.tags;
          this.isOriginal = res.original;
        })
        .catch(err => {
          this.loadingShow = false;
          this.$emit("showMessage", err);
        });
    },
    getBmobFileList(content) {
      //获取云文件列表
      const pattern = /!\[(.*?)\]\((.*?)\)/gm;
      const result = [];
      let matcher;
      while ((matcher = pattern.exec(content)) !== null) {
        result.push(matcher[2]);
      }
      this.bmobFileList = result;
    },
    autoSave() {
      //自动暂存
      //  let interval=window.setInterval(()=>{
      //     if(this.articleValue){
      //       this.save(this.articleValue,"",false)
      //     }
      //  },30000);
      this.save(this.articleValue, "", false);
    },
    save(value, render, msgShow = true) {
      //暂存
      // 存在本地localStorage
      let colAry = [];
      for (var key in this.col) {
        colAry.push(key);
      }
      let info = {
        content: value,
        title: this.articleTitle,
        col: colAry,
        chooseColumn: this.chooseColumn,
        tags: this.tags,
        articlePushId: this.articlePushId
      };
      this.saveRecord = info;
      //保存本地存储
      window.localStorage.setItem("articleInfo", JSON.stringify(info));
      this.lastTime = this.getCurrentDate(2);
      console.log("暂存成功！");
      if (msgShow) {
        this.$emit("showMessage", "文章已经暂存本地");
      }
    },
    clearLocal() {
      //清除暂存
      this.alertInfo = "确认是否清除暂存？清除后发布将作为新文章发布";
      this.alertShow = true;
    },
    confirm() {
      //移除暂存的文章
      window.localStorage.removeItem("articleInfo");
      //刷新
      location.reload();
    },
    cancel() {
      this.alertShow = false;
    },
    change(value, render) {
      this.articleHtml = render;
    },
    // 删除图片
    imgDel(pos) {
      delete this.imgListObj[pos];
    },
    // 添加图片
    imgAdd(filename, imgfile) {
      //获取更改时间戳
      let lastModified = imgfile.lastModified.toString();
      //获取文件大小
      let size = imgfile.size.toString();
      //拼接文件信息
      let tempName = `${lastModified}-${size}`;
      // 判断大小
      if (imgfile.size > 5 * 1000 * 1000) {
        //如果超过
        this.$emit("showMessage", "上传文件大小不允许超过5M");
        return;
      }
      // 判断是不是同一个文件
      if (this.imgListObj[tempName]) {
        //如果已上传的文件路径存在相同名称的文件直接替换该已上传的文件路径
        this.$refs.mavon.$img2Url(filename, this.imgListObj[tempName]);
        return;
      }
      // 上传文件到Bmob
      let bmobFile = new Bmob.File(imgfile["name"], imgfile); //设置上传文件名，文件流
      // 开始上传
      this.allowPush = false; //上传时关闭发布功能
      bmobFile
        .save()
        .then(res => {
          //存储已上传的文件路径
          this.bmobFileList.push(res[0].url);
          //记录MarkDown所有文件图片路径
          this.imgListObj[tempName] = res[0].url;
          // 将返回的url替换到markDown文本原位置![...](0) -> ![...](url)
          this.$refs.mavon.$img2Url(filename, res[0].url);
          this.$emit("showMessage", imgfile["name"] + "上传成功");
          this.allowPush = true; //上传后开启发布功能
        })
        .catch(err => {
          this.$emit("showMessage", imgfile["name"] + "上传失败");
          this.allowPush = true; //上传失败也要开启发布功能
        });
    },
    addColumn() {
      this.addColumnShow = true;
      this.$nextTick(() => {
        this.$refs.addColumn.focus();
      });
    },
    addColumnSure() {
      let flag = false;
      this.addColumnInfo = this.addColumnInfo.trim();
      // 如果输入为空，已经存在了，直接返回
      // 如果添加了栏目，则添加后并选中
      if (this.col.length === 0) {
        flag = false;
      } else {
        for (const k in this.col) {
          if (this.addColumnInfo === this.col[k]) {
            flag = true;
            break;
          }
        }
      }

      if (!this.addColumnInfo) {
        this.$emit("showMessage", "内容不能为空");
        this.addColumnShow = false;
        return;
      }
      if (!this.checkString(this.addColumnInfo)) {
        //不符合规则
        this.$emit("showMessage", "不能包含特殊字符");
        return;
      }
      if (flag) {
        //已经存在
        this.$emit("showMessage", "此分类已存在");
        return;
      }
      this.addColumnShow = false;
      // this.col[this.addColumnInfo] = this.chooseColumnId;
      this.col[this.addColumnInfo] = 0;
      this.chooseColumn = this.addColumnInfo;
      this.addColumnInfo = "";
    },
    chooseCol(col) {
      this.chooseColumn = col;
    },
    addTagsSure() {
      let index;
      this.enterTagsInfo = this.enterTagsInfo.trim();
      if (this.tags.length === 0) {
        index = -1;
      } else {
        index = this.tags.findIndex((value, index, arr) => {
          return value === this.enterTagsInfo;
        });
      }

      if (!this.enterTagsInfo) {
        //输入内容为空
        this.$emit("showMessage", "内容不能为空");
        return;
      }
      if (this.enterTagsInfo.length > 20) {
        //输入长度过长
        this.$emit("showMessage", "标签不能超过20个字符");
        return;
      }
      if (!this.checkString(this.enterTagsInfo)) {
        //不符合规则
        this.$emit("showMessage", "不能包含特殊字符");
        return;
      }
      if (index > -1) {
        //已经存在
        this.$emit("showMessage", "此标签已存在");
        return;
      }
      if (this.tags.length >= 5) {
        //tags大于5个
        this.$emit("showMessage", "标签不能超过5个");
        this.enterTagsInfo = "";
        return;
      }
      this.tags.push(this.enterTagsInfo);
      this.enterTagsInfo = "";
    },
    deleteTag(e) {
      const index = e.target.getAttribute("index");
      this.tags.splice(index, 1);
    },
    checkString(string) {
      var rule = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;
      return rule.test(string);
    },
    addArticle(type) {
      //检查必填项
      var result = this.checkAll();
      if (!result) {
        return;
      }
      var data = {
        userId: this.getUserId(),
        mainTitle: this.articleTitle,
        tags: this.tags.join("，"),
        intro: this.articleHtml.replace(/\"/g, "'").substring(0, 120),
        col: this.chooseColumn,
        content: this.articleValue.replace(/\"/g, "'"),
        render: this.articleHtml.replace(/\"/g, "'"),
        original: this.isOriginal
      };
      data["wordCount"] = data.content.length; // 文章总字节数
      if (type) {
        //点击发布文章
        //如果有articlePushId说明是旧文章的发布，传入文章ID,用来更新文章，没有传则是增加新文章
        if (this.articlePushId) {
          data["objectId"] = this.articlePushId;
        }
        //发布文章
        this.loadingShow = true;
        pushArticle(data).then(
          res => {
            this.loadingShow = false;
            this.articlePushId
              ? this.$emit("showMessage", "更新文章成功！")
              : this.$emit("showMessage", "发布文章成功！");
            //跳转我的所有文章
            this.$router.push({ name: "BAllBlog" });
            //重新加载文章
            this.reLoadList();
            // 判断是草稿箱的发布还是新文章的发布
            if (this.draftPushId) {
              //如果是草稿箱的发布
              //从草稿箱删除这篇文章
              deatroyDraft(this.draftPushId);
            }
            //移除暂存的文章
            window.localStorage.removeItem("articleInfo");
            //删除未引用的已上传的图片
            this.delBmobFile(this.bmobFileList, data.content);
          },
          err => {
            this.loadingShow = false;
            this.$emit("showMessage", err);
          }
        );
      } else {
        // 点击保存草稿
        //如果有draftPushId说明是旧草稿，传入草稿文章ID,用来更新草稿箱的文章，没有则是增加新草稿
        if (this.draftPushId) {
          data["objectId"] = this.draftPushId;
        }
        //发布草稿
        this.loadingShow = true;
        pushDraft(data).then(
          res => {
            this.loadingShow = false;
            this.draftPushId
              ? this.$emit("showMessage", "更新草稿成功！")
              : this.$emit("showMessage", "保存草稿成功！");
            // 判断是旧文章的保存草稿还是新文章的保存草稿
            if (this.articlePushId) {
              //如果是旧文章的保存草稿
              //从全部文章删除这篇文章
              deatroyArticle(this.articlePushId).then(res => {
                //重新加载文章
                this.reLoadList();
                //跳转我的草稿箱
                this.$router.push({ name: "BDraft" });
              });
            } else {
              //新文章的保存草稿
              //跳转我的草稿箱
              this.loadingShow = false;
              this.$router.push({ name: "BDraft" });
            }
            //移除暂存的文章
            window.localStorage.removeItem("articleInfo");
            //删除未引用的已上传的图片
            this.delBmobFile(this.bmobFileList, data.content);
          },
          err => {
            this.loadingShow = false;
            this.$emit("showMessage", err);
          }
        );
      }
    },
    //批量删除未引用的已上传的图片(版本问题，函数失效)
    delBmobFile(files, markDownContent) {
      //删除Bmob文件
      //已上传的列表对比markDownContent获取没有引用的图片路径
      const delList = [];
      const del = Bmob.File();
      files.forEach(item => {
        if (markDownContent.indexOf(item) === -1) {
          delList.push(item);
        }
      });
      //传入要删除的文件地址
      delList.length && del.destroy(delList);
    },
    reLoadList() {
      //清空数据
      this.$emit("clearArticleList");
      //重新加载数据
      this.$emit("getArticleList");
      // 重新获取分类
      this.$emit("getCategories");
      // 重新获取文章字数
      this.$emit("getWordCount");
    },
    initUserInfo() {
      currentUser()
        .then(result => {
          this.userId = result.objectId;
          this.initPage();
        })
        .catch(err => {
          //没有session，未登录（未按步骤操作）
          this.$router.push({ path: "/login" });
        });
    },
    checkAll() {
      if (this.articleTitle === "") {
        this.$emit("showMessage", "请填写博客标题");
        return false;
      }
      if (this.chooseColumn === "") {
        this.$emit("showMessage", "请填写分类");
        return false;
      }
      if (this.tags.length <= 0) {
        this.$emit("showMessage", "请填写标签");
        return false;
      }
      if (this.articleValue === "") {
        this.$emit("showMessage", "博客内容不能为空");
        return false;
      }
      return true;
    },
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase();
      var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      var bIsMidp = sUserAgent.match(/midp/i) == "midp";
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      var bIsAndroid = sUserAgent.match(/android/i) == "android";
      var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      /*document.writeln("您的浏览设备为：");*/
      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        return true;
      } else {
        return false;
      }
    },
    /**
     *获取当前时间
     *format=1精确到天
     *format=2精确到分
     */
    getCurrentDate(format) {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      //精确到天
      if (format == 1) {
        time = year + "-" + month + "-" + date;
      }
      //精确到分
      else if (format == 2) {
        time =
          year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      }
      return time;
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../../../assets/style/common.less");
.WriteBlog {
  position: relative;
  bottom: 0;
  left: 200px;
  right: 0;
  background-color: #fff;
  padding: 0 2%;
  overflow: auto;
  width: calc(~"100% - 200px - 61px");
  h2 {
    margin: 40px 0 0;
    font-size: 28px;
    color: #b1b1b1;
  }
  .editor {
    margin: 30px 0 0;
    min-width: 1024px;
    .mavonEditor {
      max-height: 800px;
    }
    @media (max-width: 1400px) {
      .mavonEditor {
        max-height: 400px;
      }
    }
    .title {
      border: 1px solid rgba(0, 0, 0, 0.157);
      position: relative;
      &::before {
        content: "";
        position: absolute;
        top: 20px;
        left: 66px;
        border-top: 7px solid #888;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
      }
    }
    .recordInfo {
      padding: 10px 0;
      color: #999999;
      font-family: Menlo, "Ubuntu Mono", Consolas, "Courier New",
        "Microsoft Yahei", "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
      font-size: 15px;
      text-align: right;
      margin-top: unset;
      margin-bottom: unset;
    }
    .original {
      width: 90px;
      height: 40px;
      border: 0;
      border: 0;
      padding-left: 24px;
      font-size: 16px;
      color: #666;
      background: #fff;
    }
    input {
      height: 45px;
      width: 900px;
      line-height: 45px;
      padding-left: 15px;
      box-sizing: border-box;
      border-left: 1px solid rgba(0, 0, 0, 0.157);
    }
  }
  .title {
    line-height: 24px;
    .chinese {
      font-size: 18px;
      color: #333333;
    }
    .english {
      font-size: 14px;
      color: #999999;
    }
  }
  .loading {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.06);
    .icon {
      position: absolute;
      top: 42%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 24px;
      color: #26a69a;
      animation: rotate 1s steps(8) 0s infinite;
    }
    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  }
  .column {
    margin-top: 40px;
    min-height: 68px;
    .clearfixMixin();
    ul {
      li {
        min-width: 70px;
        margin-top: 10px;
        line-height: 26px;
        box-sizing: border-box;
        border-radius: 2px;
        font-size: 14px;
        text-align: center;
        float: left;
        margin-right: 12px;
        border: 1px solid #b1b1b1;
        color: #b1b1b1;
        padding: 0 6px;
        cursor: pointer;
        &.active,
        &:hover {
          border: 1px solid #26a69a;
          color: #26a69a;
        }
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .more {
      min-width: 70px;
      line-height: 26px;
      box-sizing: border-box;
      border-radius: 2px;
      border: 0;
      font-size: 14px;
      margin-right: 12px;
      margin-top: 10px;
      cursor: pointer;
      color: #fff;
      background-color: #26a69a;
      vertical-align: top;
      &:hover {
        background-color: #1a8a7f;
      }
    }
    .addColumn {
      display: inline-block;
      margin-right: 12px;
      font-size: 0;
      margin-top: 10px;
      input {
        width: 120px;
        line-height: 28px;
        font-size: 14px;
        height: 28px;
        box-sizing: border-box;
        padding-left: 6px;
        border: 1px solid #b1b1b1;
        vertical-align: bottom;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
      }
      button {
        width: 50px;
        height: 28px;
        vertical-align: bottom;
        background-color: #26a69a;
        color: #fff;
        border: 0;
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
        cursor: pointer;
        &:hover {
          background-color: #1a8a7f;
        }
      }
    }
  }
  .tags {
    margin-top: 30px;
    min-height: 68px;
    .addTagsInfo {
      .clearfixMixin();
      li {
        position: relative;
        margin-top: 10px;
        height: 26px;
        float: left;
        cursor: pointer;
        margin-right: 24px;
        .info {
          line-height: 24px;
          padding: 0 0 0 5px;
          float: left;
          border: 1px solid #26a69a;
          background-color: #26a69a;
          color: #fff;
          i {
            display: inline-block;
            font-size: 18px;
            line-height: 18px;
            width: 16px;
            text-align: center;
            &:hover {
              color: #e91e63;
            }
          }
        }
        .bugle {
          position: absolute;
          top: 0;
          font-size: 0;
          width: 0;
          height: 0;
          border-top: 13px solid transparent;
          border-left: 10px solid #26a69a;
          border-bottom: 13px solid transparent;
          vertical-align: middle;
        }
      }
    }
    .input {
      margin-top: 10px;
      display: inline-block;
      min-width: 300px;
      line-height: 30px;
      border: 1px solid #b1b1b1;
      input {
        height: 28px;
        width: 100%;
        padding-left: 10px;
        box-sizing: border-box;
      }
    }
  }
  .button {
    margin-top: 40px;
    margin-bottom: 40px;
    button {
      min-width: 80px;
      height: 30px;
      border-radius: 2px;
      margin-right: 10px;
      background-color: #778a9d;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        background-color: #5f6f7f;
      }
      &:active {
        background-color: #555;
      }
      &.active {
        background-color: #26a69a;
        &:hover {
          background-color: #1a8a7f;
        }
        &:active {
          background-color: #0e5d56;
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  .WriteBlog {
    position: relative;
    top: 0;
    bottom: 50px;
    padding-bottom: 30px;
    left: 0;
    width: auto;
    h2 {
      margin-top: 0;
    }
    .editor {
      min-width: 100%;
      input {
        width: auto;
      }
    }
    .button {
      text-align: center;
      margin-top: 30px;
    }
  }
}
</style>

<style>
.v-note-wrapper .v-note-op,
.v-note-wrapper .v-note-panel {
  /* display: none; */
  box-shadow: 0 0 0 !important;
  border: 1px solid rgba(0, 0, 0, 0.157) !important;
  border-top: none !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?33c5da6c